<template functional>
    <b-badge 
        v-if="props.badge_title || props.title || props.name" 
        v-b-tooltip="{ title: props.title, trigger: 'hover', boundary: 'window', disabled: props.noTooltip }"
        :variant="(props.bare ? 'bare-' : (props.gray ? 'gray-' : 'soft-')) + props.color_variant"
        :class="[(props.textUppercase ? 'text-uppercase' : ''), (data.staticClass || ''), (data.class || '')]"
        :style="{
            whiteSpace: props.noWrap ? 'nowrap' : 'normal',
            fontSize: props.fontSize ? props.fontSize : '',
        }"
    >
        <b-icon 
            v-if="props.icon && !props.hideIcon"
            :icon="props.icon" 
            :variant="props.color_variant"            
        ></b-icon>
        {{props.badge_title || props.title}}
    </b-badge>
</template>

<script>

// use v-bind="stateObj"  - with the state object or state definition -- make sure it works with either 

export default {
    functional: true,
    name: 'FlowObjectStateBadge',
    props: {
        // PROPS DIRECTLY FROM STATE / STATE DEF OBJECT
        name: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        badge_title: {  // default for this is set in backend, so we should always have it
            type: String,
            default: '',
        },
        color_variant: {  // should have default set in backend
            type: String,
            default: 'secondary',
        },
        icon: {  // optional in backend -- we set default here, if you don't want to show it, set :hideIcon="true"
            type: String,
            default: 'record-fill',
        },
        // EXTRA PROPS YOU CAN SET - NOT FROM BACKEND
        textUppercase: {
            type: Boolean,
            default: false,
        },
        fontSize: {  // should be a string, set like normal CSS size parameter (1rem, large, 1em, etc...)
            type: [String, Number],
            required: false,
        },
        noWrap: {  // set this to true if you want css white-space: nowrap (default for badges)
            // but I changed default to white-space: normal so words will wrap
            type: Boolean,
            default: false,
        },
        noTooltip: {  // don't use tooltip if this is true
            type: Boolean,
            default: false,
        },
        hideIcon: {
            type: Boolean,
            default: false,
        },
        // VARIANT TYPES - bare takes priority, then gray, then default of 'soft'
        // add one for solid?  or make that default and add one for soft?
        bare: {
            type: Boolean,
            default: false,
        },
        gray: {  // if true, we use 'gray-' variant badges
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style>

</style>